import React, { useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import ApplicationsTab from './ApplicationsTab';
import EnrollmentTab from './EnrollmentTab';
import GroupsTab from './GroupsTab';
import ChildrenTab from './ChildrenTab';
import FiltersSection from './FiltersSection';
import './public-statistics.css';

const PublicStatistics = () => {
  const [activeTab, setActiveTab] = useState('applications');
  const [filters, setFilters] = useState({
    applications: {
      year: '2025 → 2026',
      registration: 'З підтвердженою реєстрац',
      municipalCard: 'Всі заявки',
      stayType: 'Всі заявки',
      benefit: 'Всі заявки',
      created: 'Всі заявки',
      invitations: 'Всі заявки',
      enrolled: 'Всі заявки'
    },
    enrollment: {
      year: '2025 → 2026',
      registration: 'З підтвердженою реєстрац',
      municipalCard: 'Всі заявки',
      stayType: 'Всі заявки',
      benefit: 'Всі заявки',
      created: 'Всі заявки',
      invitations: 'Всі заявки',
      enrolled: 'Всі заявки'
    },
    groups: {
      year: '2025 → 2026',
      district: 'Голосіївський',
      ageCategory: 'Різновікова — від 3-х років',
      placeType: 'Будь-які',
      childrenCount: 'Від 5 до 20'
    },
    children: {
      year: '2025 → 2026',
      registration: 'З підтвердженою реєстрац',
      placeType: 'Повного дня',
      specialization: 'Будь-яка',
      asOf: 'Травень'
    }
  });

  const handleFilterChange = (tab, filterName, value) => {
    setFilters(prev => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        [filterName]: value
      }
    }));
  };

  const handleApplyFilters = (tab) => {
    console.log(`Applying filters for ${tab}:`, filters[tab]);
    // Здесь будет логика применения фильтров
  };

  const getCurrentFilters = () => filters[activeTab];

  return (
    <main className="publicstatistic-main-content">
      <div className="container py-4">
        <h1 className="publicstatistic-page-title">Статистична інформація</h1>

        <div className="publicstatistic-statistics-tabs">
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="publicstatistic-nav-tabs"
            id="publicstatistic-statisticsTabs"
          >
            <Tab
              eventKey="applications"
              title="Заявки на вступ в розрізі районів"
              tabClassName="publicstatistic-nav-link"
            >
              <FiltersSection
                tab="applications"
                filters={getCurrentFilters()}
                onFilterChange={handleFilterChange}
                onApplyFilters={handleApplyFilters}
              />
              <ApplicationsTab filters={getCurrentFilters()} />
            </Tab>
            <Tab
              eventKey="enrollment"
              title="Заявки на вступ в розрізі садочків"
              tabClassName="publicstatistic-nav-link"
            >
              <FiltersSection
                tab="enrollment"
                filters={getCurrentFilters()}
                onFilterChange={handleFilterChange}
                onApplyFilters={handleApplyFilters}
              />
              <EnrollmentTab filters={getCurrentFilters()} />
            </Tab>
            <Tab
              eventKey="groups"
              title="Групи в садочках"
              tabClassName="publicstatistic-nav-link"
            >
              <FiltersSection
                tab="groups"
                filters={getCurrentFilters()}
                onFilterChange={handleFilterChange}
                onApplyFilters={handleApplyFilters}
              />
              <GroupsTab filters={getCurrentFilters()} />
            </Tab>
            <Tab
              eventKey="children"
              title="Діти в садочках"
              tabClassName="publicstatistic-nav-link"
            >
              <FiltersSection
                tab="children"
                filters={getCurrentFilters()}
                onFilterChange={handleFilterChange}
                onApplyFilters={handleApplyFilters}
              />
              <ChildrenTab filters={getCurrentFilters()} />
            </Tab>
          </Tabs>
        </div>
      </div>
    </main>
  );
};

export default PublicStatistics;